import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer/footer";
import Header from "../components/Header/header";
import useWindowSize from "../components/Hooks/windowSize";
import LeftSection from "../components/LeftSection/leftSection";
import WhiteNavbar from "../components/WhiteNavabar/whiteNavbar";
import FilterHeader from "../components/FilterHeader/filterHeader";
import RightSection from "../components/RightSection/rightSection";
import SelectResult from "../components/SelectResult/selectResult";
import MobileHeader from "../components/MobileHeader/mobileHeader";
import TutorialPopup from "../components/TutorialPopup/tutorialPopup";
import VerticalNavbar from "../components/VerticalNavbar/verticalNavbar";
import ResearchDetail from "../components/ResearchDetail/researchDetail";
import InterviewDetail from "../components/InterviewDetail/interviewDetail";
import MainMobileScreen from "../components/MainMobileScreen/mainMobileScreen";
import HeaderMobileScreen from "../components/HeaderMobileScreen/headerMobileScreen";
import InterviewImageLink from "../components/InterviewImageLink/interviewImageLink";
import MobileInterviewLink from "../components/MobileInterviewLink/mobileInterviewLink";
import MobileInterviewScreen from "../components/MobileInterviewScreen/mobileInterviewScreen";
import EducatorDetailEnglish from "../components/EducatorDetailEnglish/educatorDetailEnglish";
import MainMobileArabicScreen from "../components/MainMobileArabicScreen/mainMobileArabicScreen";
import EducatorKitMobileScreen from "../components/EducatorKitMobileScreen/educatorKitMobileScreen";
import EducatorKitArabicMobileScreen from "../components/EducatorKitArabicMobileScreen/educatorKitArabicMobileScreen";
import { dummyArabic, dummyEnglish } from "../assets/text/dummy";

const Main = () => {
  const [applyState, setApplyState] = useState(false);
  const [reset, setReset] = useState(false);
  const [selectState, setSelectState] = useState(false);
  const [navbarEducator, setNavbarEducator] = useState(false);
  const [navbarResearch, setNavbarResearch] = useState(false);
  const [navbarInterview, setNavbarInterview] = useState(false);
  const [showWhite, setShowWhite] = useState(false);
  const [width, height] = useWindowSize();
  const [imageLink, setImageLink] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [active, setActive] = useState(false);
  const [englishTextValue, setEnglishTextValue] = useState(dummyEnglish);
  const [arabicTextValue, setArabicTextValue] = useState(dummyArabic);
  const [filtersApplied, setAppliedFilters] = useState([-1, -1, -1, -1, -1]);
  const [resultEngDescription, setResultEngDescription] = useState();
  const [resultArabDescription, setResultArabDescription] = useState();
  const [resultImage, setResultImage] = useState();
  const [resultId, setResultId] = useState();
  const [resultPdfId, setResultPdfId] = useState();
  const [resultPreviewImage, setResultPreviewImage] = useState();
  const [interviewContent, setInterviewContent] = useState({});

  const navigate = useNavigate();

  useEffect(() => {
    if (reset) {
      setEnglishTextValue("");
      setArabicTextValue("");
      setReset(false);
    }
  }, [reset]);

  const handleMovingToLandingPage = () => {
    const anyOpen = navbarEducator || navbarResearch || navbarInterview;

    if (anyOpen) {
      // Close all sections and return to the main builder
      setNavbarEducator(false);
      setNavbarInterview(false);
      setNavbarResearch(false);
      setActive(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Already at initial state → go to the intro page
      navigate("/");
    }
  };

  const handleFiltersApplied = (array) => {
    setAppliedFilters(array);
  };

  // const handleTextAreaValue = (englishValue, arabicValue) => {
  //   setEnglishTextValue(englishValue);
  //   setArabicTextValue(arabicValue);
  // };

  const handleEnglishTextAreaValue = (englishValue) => {
    setEnglishTextValue(englishValue);
  };

  const handleArabicTextAreaValue = (arabicValue) => {
    setArabicTextValue(arabicValue);
  };

  const handleImageLink = (link, interviewContent) => {
    setImageLink(link);
    setInterviewContent(interviewContent);
    window.scrollTo(0, 0);
  };

  const handleApply = (applyButton) => {
    // if there's no text and the apply is for the new results (not for resetting)
    if (
      (englishTextValue.length === 0 || arabicTextValue.length === 0) &&
      applyButton
    ) {
      window.alert("Please Enter text in both English and Arabic text fields:");
    } else {
      setApplyState(applyButton);
    }
  };

  const handleReset = (val) => {
    setReset(val);
    setApplyState(false);
    setSelectState(false);
  };

  const handleSelectResult = (
    selectButton,
    resultImage,
    resultEngText,
    resultArabText,
    id,
    pdfID,
    previewImage
  ) => {
    setSelectState(selectButton);
    setResultEngDescription(resultEngText);
    setResultArabDescription(resultArabText);
    setResultImage(resultImage);
    setResultId(id);
    setResultPdfId(pdfID);
    setResultPreviewImage(previewImage);
  };

  const handleNavbarClick = (buttonClick, navbarNumber) => {
    // console.log("State===>", buttonClick, "Navbar Number===>", navbarNumber);
    setShowWhite(true);
    const handleDelay = () => {
      setShowWhite(false);
      if (navbarNumber === 1) {
        if (!navbarEducator && !navbarResearch && !navbarInterview) {
          setNavbarEducator(true);
        } else if (navbarEducator && !navbarResearch && !navbarInterview) {
          setNavbarEducator(false);
        } else if (navbarInterview && navbarResearch) {
          setNavbarResearch(false);
          setNavbarInterview(false);
        } else if (navbarResearch) {
          setNavbarResearch(false);
        }
      } else if (navbarNumber === 2) {
        if (!navbarResearch) {
          setNavbarResearch(true);
          setNavbarEducator(true);
        } else if (navbarResearch && navbarEducator && !navbarInterview) {
          setNavbarResearch(false);
        } else if (navbarEducator === false) {
          setNavbarEducator(true);
        } else if (navbarInterview === true) {
          setNavbarInterview(false);
        }
      } else if (navbarNumber === 3) {
        if (!navbarInterview && !navbarEducator && !navbarResearch) {
          setNavbarInterview(true);
          setNavbarEducator(true);
          setNavbarResearch(true);
        } else if (!navbarInterview && !navbarResearch) {
          setNavbarInterview(true);
          setNavbarResearch(true);
        } else if (!navbarInterview) {
          setNavbarInterview(true);
        } else if (navbarInterview) {
          setNavbarInterview(false);
        } else if (!navbarInterview && navbarEducator && navbarResearch) {
          setNavbarInterview(true);
          setNavbarResearch(false);
        } else if (!navbarResearch && !navbarInterview) {
          setNavbarResearch(true);
          setNavbarInterview(true);
        }
      }
      setActive(active === navbarNumber ? navbarNumber - 1 : navbarNumber);
    };
    setTimeout(handleDelay, 500);
  };

  const handleMobileNavigation = (screen) => {
    if (screen === "educator") {
      setNavbarInterview(false);
      setNavbarResearch(false);
      setNavbarEducator(true);
    } else if (screen === "research") {
      setNavbarEducator(false);
      setNavbarInterview(false);
      setNavbarResearch(true);
    } else if (screen === "interview") {
      setNavbarEducator(false);
      setNavbarResearch(false);
      setNavbarInterview(true);
    }
  };
  const handleToggle = (value) => {
    setToggle(value);
  };

  return (
    <div style={{ height: "100%" }}>
      <div
        style={{
          display: "flex",
          width: "100%",
          height: "90%",
        }}
      >
        {width < 767 && width > 320 ? null : (
          <>
            <div className="main-section-navbar">
              <VerticalNavbar
                textArab={"افعلهـــــا بنفســــك"}
                textEng={"do it yourself"}
                first={true}
                handleMovingToLandingPage={handleMovingToLandingPage}
                navbarEducator={navbarEducator}
                clickState={navbarEducator}
              />
            </div>
            {navbarEducator && (
              <div className="main-section-navbar">
                <VerticalNavbar
                  textArab={"أدوات التعليــــم"}
                  textEng={"educator's kit"}
                  handleNavbarClick={handleNavbarClick}
                  clickState={navbarEducator}
                  navbarNumber={1}
                  active={active}
                />
              </div>
            )}
            {navbarResearch && (
              <div className="main-section-navbar">
                <VerticalNavbar
                  textArab={"البحــــث"}
                  textEng={"research"}
                  handleNavbarClick={handleNavbarClick}
                  clickState={navbarResearch}
                  navbarNumber={2}
                  active={active}
                />
              </div>
            )}
            {navbarInterview && (
              <div className="main-section-navbar">
                <VerticalNavbar
                  textArab={"مقـــــابلات"}
                  textEng={"interviews"}
                  handleNavbarClick={handleNavbarClick}
                  clickState={navbarInterview}
                  navbarNumber={3}
                  active={active}
                />
              </div>
            )}
          </>
        )}

        <div className="main-section-body">
          {showWhite && <WhiteNavbar />}
          {navbarEducator && !navbarInterview && !navbarResearch ? (
            <>
              {toggle ? (
                <HeaderMobileScreen
                  title={"EDUCATOR'S KIT"}
                  download={"eng"}
                  toggle={toggle}
                />
              ) : (
                <HeaderMobileScreen
                  title={"أدوات التعليــــم"}
                  download={"arab"}
                  toggle={toggle}
                />
              )}
            </>
          ) : navbarResearch && !navbarInterview ? (
            <>
              {toggle ? (
                <HeaderMobileScreen
                  title={"RESEARCH"}
                  download={false}
                  toggle={toggle}
                />
              ) : (
                <HeaderMobileScreen
                  title={"البحـــــث"}
                  download={false}
                  toggle={toggle}
                />
              )}
            </>
          ) : navbarInterview ? (
            <>
              {toggle ? (
                <HeaderMobileScreen
                  title={"INTERVIEWS"}
                  download={false}
                  toggle={toggle}
                  handleImageLink={handleImageLink}
                />
              ) : (
                <HeaderMobileScreen
                  title={"مقــــابلات"}
                  download={false}
                  toggle={toggle}
                  handleImageLink={handleImageLink}
                />
              )}
            </>
          ) : null}
          {width > 1125 ? (
            <Header
              handleMovingToLandingPage={handleMovingToLandingPage}
              navbarEducator={navbarEducator}
            />
          ) : (
            <MobileHeader
              handleMobileNavigation={handleMobileNavigation}
              handleToggle={handleToggle}
              handleMovingToLandingPage={handleMovingToLandingPage}
              toggle={toggle}
              handleImageLink={handleImageLink}
            />
          )}
          {!navbarEducator && (
            <FilterHeader
              handleApply={handleApply}
              applyState={applyState}
              handleReset={handleReset}
              reset={reset}
              handleFiltersApplied={handleFiltersApplied}
              filterApplied={filtersApplied}
            />
          )}
          {width < 1125 && width > 320 ? (
            <>
              {navbarEducator && !navbarInterview && !navbarResearch ? (
                <>
                  {toggle ? (
                    <EducatorKitMobileScreen />
                  ) : (
                    <EducatorKitArabicMobileScreen />
                  )}
                </>
              ) : navbarResearch && !navbarInterview ? (
                <ResearchDetail toggle={toggle} width={width} height={height} />
              ) : navbarInterview ? (
                imageLink ? (
                  <MobileInterviewLink
                    toggle={toggle}
                    handleImageLink={handleImageLink}
                    content={interviewContent}
                  />
                ) : (
                  <MobileInterviewScreen
                    handleImageLink={handleImageLink}
                    toggle={toggle}
                  />
                )
              ) : (
                <>
                  {toggle ? (
                    <MainMobileScreen
                      handleImageLink={handleImageLink}
                      handleMobileNavigation={handleMobileNavigation}
                    />
                  ) : (
                    <MainMobileArabicScreen
                      handleImageLink={handleImageLink}
                      handleMobileNavigation={handleMobileNavigation}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <div
              className="main-sections"
              style={{
                height: navbarEducator ? height - 129 : height - 168,
              }}
            >
              {navbarEducator && !navbarResearch ? (
                <>
                  <EducatorDetailEnglish width={width} height={height} />
                </>
              ) : navbarResearch && !navbarInterview ? (
                <ResearchDetail toggle={toggle} width={width} height={height} />
              ) : navbarInterview ? (
                imageLink ? (
                  <InterviewImageLink
                    handleImageLink={handleImageLink}
                    content={interviewContent}
                    width={width}
                    height={height}
                  />
                ) : (
                  <InterviewDetail handleImageLink={handleImageLink} />
                )
              ) : (
                <>
                  <LeftSection
                    applyAbled={applyState}
                    reset={reset}
                    handleEnglishTextAreaValue={handleEnglishTextAreaValue}
                    handleArabicTextAreaValue={handleArabicTextAreaValue}
                    englishTextValue={englishTextValue}
                    arabicTextValue={arabicTextValue}
                  />
                  {selectState ? (
                    <SelectResult
                      handleApply={handleSelectResult}
                      applyState={selectState}
                      englishTextValue={englishTextValue}
                      arabicTextValue={arabicTextValue}
                      resultEngDescription={resultEngDescription}
                      resultArabDescription={resultArabDescription}
                      resultImage={resultImage}
                      resultId={resultId}
                      pdfId={resultPdfId}
                      previewImage={resultPreviewImage}
                    />
                  ) : (
                    applyState && (
                      <RightSection
                        handleSelectResult={handleSelectResult}
                        selectState={selectState}
                        filtersApplied={filtersApplied}
                        applyState={applyState}
                      />
                    )
                  )}
                </>
              )}

              {!navbarEducator && !navbarResearch && !navbarInterview && (
                <TutorialPopup />
              )}
            </div>
          )}
          <Footer />
        </div>
        {!navbarEducator && (
          <div className="main-section-navbar">
            <VerticalNavbar
              textArab={"أدوات التعليــــم"}
              textEng={"educator's kit"}
              handleNavbarClick={handleNavbarClick}
              clickState={navbarEducator}
              navbarNumber={1}
              active={active}
            />
          </div>
        )}
        {!navbarResearch && (
          <div className="main-section-navbar">
            <VerticalNavbar
              textArab={"البحــــث"}
              textEng={"research"}
              handleNavbarClick={handleNavbarClick}
              clickState={navbarResearch}
              navbarNumber={2}
              active={active}
            />
          </div>
        )}
        {!navbarInterview && (
          <div className="main-section-navbar">
            <VerticalNavbar
              textArab={"مقــــابلات"}
              textEng={"interviews"}
              handleNavbarClick={handleNavbarClick}
              clickState={navbarInterview}
              navbarNumber={3}
              active={active}
            />
          </div>
        )}
      </div>
    </div>
  );
};
export default Main;
